<template>

<div class="bridge-complete">

	<div class="bridge-complete-icon"></div>

	<div class="bridge-complete-title">Patient Code Generated</div>

	<div class="bridge-complete-code">{{ code }}</div>

	<div class="bridge-complete-text">
		<p>Please share this code with the patient. They can use it to access their personalised version of the Osteoporosis Options tool.</p>
		<p>The code can be sent via email or SMS text.</p>
	</div>

	<button class="bridge-complete-button" v-on:click="$emit('done')">Done</button>

</div>

</template>

<script>

export default {

	computed: {

		code: function() {

			return this.$store.getters['session/bridge/code']

		}

	}

}

</script>

<style scoped>

.bridge-complete {
	margin-top: 48px;
	padding: 48px;
	background-color: #f8f8f8;
	border-radius: 16px;
	text-align: center;
}

.bridge-complete-icon {
	width: 64px;
	height: 64px;
	margin: 0 auto 24px;
	border-radius: 50%;
	background-color: #4CAF50;
	background-image: url(~@/assets/section.foot.chevron.svg);
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.bridge-complete-title {
	font-size: 20px;
	font-weight: 700;
	color: #343434;
	margin-bottom: 16px;
}

.bridge-complete-code {
	font-size: 36px;
	font-weight: 700;
	letter-spacing: 6px;
	color: var(--primary-color);
	padding: 16px 32px;
	background-color: #fff;
	border: 2px solid var(--primary-color);
	border-radius: 12px;
	display: inline-block;
	margin-bottom: 24px;
	font-family: monospace;
}

.bridge-complete-text {
	font-size: 14px;
	color: #666;
	line-height: 22px;
	max-width: 500px;
	margin: 0 auto 24px;
}

.bridge-complete-text p {
	margin-bottom: 8px;
}

.bridge-complete-button {
	padding: 12px 48px;
	background-color: var(--primary-color);
	color: #fff;
	border: none;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 200ms ease-in-out;
}

.bridge-complete-button:hover {
	filter: brightness(90%);
}

</style>
